import React from "react"
import { StyleProp, StyleSheet, View, ViewStyle } from "react-native"

type Props = {
  icon: React.ReactNode
  style?: StyleProp<ViewStyle>
}
const Badge = ({icon, style={}}: Props) => {
  return (
    <View style={[styles.badge, style]}>
      {icon}
    </View>
  )
}

export default Badge

const styles = StyleSheet.create({
  badge: {
    borderRadius: 25,
    height: 20,
    width: 20,
    justifyContent: "center",
    alignItems: "center"
  }
})